import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalespersonsDataGrid } from "src/components/views/erp/sales/masterData/salespersons/SalespersonsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/salespersons")({
	staticData: { title: i18n.t("salespersons"), legacyViewKey: "salespersonsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalespersonsDataGrid />;
}
